export default "__VITE_ASSET__2963b306__"